export const getPermissionsForMenu = (menuPath) => {
  const raw = sessionStorage.getItem("GranulesRolePermissions");
  if (!raw) return {};

  const permissions = JSON.parse(raw);
  return permissions.find((p) => p.MenuPath === menuPath) || {};
};
